<template>

    <div class="relative suggestive-search">
        <div class="input-form mt-3">
            <form :action="formActionSearch" method="GET" @submit="doSubmit">
                <div class="flex flex-nowrap content-center items-center border-b border-white">
                    <input type="text" id="Search" name="Search" v-on:keyup="updateQuery" v-model="holdingSearchTerm"
                        class="border-0 p-2 text-white placeholder:text-white/90 bg-transparent text-base placeholder:text-base pl-0 focus:border-none focus:ring-0"
                        placeholder="I'm looking for..."
                        aria-label="Search terms"/>
                    <button v-if="holdingSearchTerm" class="border-0 border-none p-0 btn border-dark-blue -ml-[50px]"
                        type="submit">
                        <img :src="searchIcon" alt="Search icon"  width="20" height="20" class="border-0 p-0">
                    </button>
                    <a v-else :href="resultsPageClean">
                        <img :src="searchIcon" alt="Search icon" width="20" height="20" class="border-0 p-0">
                        <span class="sr-only">Search</span>
                    </a>
                </div>

            </form>
        </div>


        <div class="absolute w-full bg-white text-center results top left">
            <div>
                <div v-for="term in readPages"
                    class="cursor-pointer overflow-hidden border border-l-4 p-4 border-dark-blue"
                    v-on:click.prevent="goTo(term.absoluteLink)">
                    <p class="flex-1 text-base text-black text-left">
                        <a :href="term.absoluteLink">
                            {{ term.title }}
                        </a>
                    </p>
                    <div class="text-left text-black text-sm">{{ term.summary }}</div>
                </div>
                <div v-if="readPages" class="cursor-pointer overflow-hidden border border-l-4 p-4 border-dark-blue">
                    <p class="flex-1 text-base text-black text-left">
                        <a :href="formActionSearch">
                            See All Results
                        </a>
                    </p>
                </div>
            </div>
            <div v-if="$apollo.queries.readPages.loading">
                Loading...
            </div>
        </div>


    </div>

</template>

<script>
import {debounce} from "lodash";
import gql from 'graphql-tag';

export default {
    name: "SuggestiveSearch",
    data: {
        holdingSearchTerm: '',
        searchTerm: ''
    },
    computed: {
        formActionSearch: function () {
            return decodeURIComponent(this.formAction) + '?Search=' + this.searchTerm + '&action_results=Go';
        },
        resultsPageClean: function () {
            return decodeURIComponent(this.formAction.replace('SearchForm/', ''));
        }
    },
    props: {
        formAction: {
            type: String,
            required: false
        },
        searchIcon: {
            type: String,
            required: false
        }
    },
    methods: {
        goTo: function (link) {
            if (link) {
                window.location.href = link;
            }
        },
        doSubmit: function () {
            window.location.href = this.formActionSearch;
        },
        updateQuery: _.debounce(
            function () {
                this.searchTerm = (this.holdingSearchTerm.length > 2) ? this.holdingSearchTerm : '';
            }, 700)
    },
    apollo: {
        readPages: {
            query: gql`
                query readPages($searchTerm: String!) {
                    readPages(filter: {allContent: { contains: $searchTerm } }, limit: 4) {
                        nodes {
                          title
                          summary
                          metaDescription
                          absoluteLink
                        }
                    }
                }
            `,
            variables() {
                return {
                    searchTerm: this.searchTerm
                }
            },
            skip() {
                return this.searchTerm.length <= 2;
            },
            update: data => data.readPages.nodes
        }
    },
}
</script>

<style scoped>

</style>
